
// Safari on iOS does *not* support the :active pseudo CSS class
// by default. Apparently the below is a workaround that enables it.
// See: https://stackoverflow.com/questions/3885018/active-pseudo-class-doesnt-work-in-mobile-safari
document.addEventListener("touchstart", function() {}, false);
